import { Box, Center, Spinner, VStack, Text } from '@chakra-ui/react';
import { Inbox } from 'lucide-react';
import { Trans } from '@lingui/react/macro';
import { trpcAdmin } from '@duke-hq/app-admin-web/lib/trpcAdmin';
import { StudentContactsRow } from './StudentContactsRow';

interface StudentContactsListProps {
  studentDrn: string;
  enrolmentId?: number;
}

export function StudentContactsList({ studentDrn, enrolmentId }: StudentContactsListProps) {
  const { data, isLoading } = trpcAdmin.students.contactHistory.useQuery({
    drn: studentDrn,
    enrolmentId,
  });

  if (isLoading) {
    return (
      <Center h="100vh">
        <Spinner size="xl" />
      </Center>
    );
  }

  if (data === undefined || data.length === 0) {
    return (
      <Center py={8}>
        <VStack spacing={2}>
          <Inbox size={48} color="var(--chakra-colors-fg-muted)" />
          <Text color="fg.muted">
            <Trans>No contacts found</Trans>
          </Text>
        </VStack>
      </Center>
    );
  }

  return (
    <Box>
      <VStack spacing={0} align="stretch">
        {data.map((contact) => (
          <StudentContactsRow key={contact.id} contact={contact} />
        ))}
      </VStack>
    </Box>
  );
}
